import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import withLocalization from '../../../hoc/withLocalization';
import CustomMultiSelect from '../../../elements/CustomMultiSelect';

const UserLeaveTypeGrantsWidgetMobx = inject('commonStore', 'userStore')(withLocalization(observer(class UserLeaveTypeGrantsWidgetMobx extends Component {
    componentDidMount() {
        const userId = this.props.options?.user_id;
        if (!userId) return;
        this.props.userStore.getUserLeaveTypeGrants(userId)
            .then(res => this.props.onChange((res.codes || []).join(',')))
            .catch(err => console.error(err));
    }

    render() {
        const { t, value, onChange, disabled } = this.props;
        const notDefaultTypes = (this.props.commonStore?.config?.allAbsentTypes || []).filter(type => type.isDefault === false);
        const options = notDefaultTypes.map(type => ({ label: t(type.name), value: type.code }));
        const selectedOptions = value ? (Array.isArray(value) ? value : value.split(',')) : [];

        return (
            <CustomMultiSelect
                options={options}
                value={selectedOptions}
                onChange={(selected) => onChange(selected.map(opt => opt.value).join(','))}
                returnObject
                disabled={disabled}
                className="leave-type-multiselect"
                overrideStrings={{
                    selectSomeItems: t('Select Leave Types'),
                    allItemsAreSelected: t('All leave types are selected'),
                    search: t('Search'),
                    selectAll: t('Select All'),
                    noOptions: t('No leave types are marked Not Default, you can add them in the control panel under Absence Types'),
                }}
            />
        );
    }
})));

export default class UserLeaveTypeGrantsWidget extends Component {
    render() {
        return <UserLeaveTypeGrantsWidgetMobx {...this.props} />;
    }
}
